import {
  ManageExaminationTallyComponent
} from "../components/operations/tally/manage-tally/manage-examination-tally/manage-examination-tally.component";
import { Cycle, CycleType } from "./app-constants";
import {
  ManageLclDeliveryTallyComponent
} from "../components/operations/tally/manage-tally/manage-lcl-delivery-tally/manage-lcl-delivery-tally.component";
import {
  ManageSmtpStuffingTallyComponent
} from "../components/operations/tally/manage-tally/manage-smtp-stuffing-tally/manage-smtp-stuffing-tally.component";
import {
  ManageTallySmtpContainerDeliveryComponent
} from "../components/operations/tally/manage-tally/manage-tally-smtp-container-delivery/manage-tally-smtp-container-delivery.component";
import {
  ManageTallySmtpTruckMovementComponent
} from "../components/operations/tally/manage-tally/manage-tally-smtp-truck-movement/manage-tally-smtp-truck-movement.component";
import {
  ManageTallyDestuffingFclComponent
} from "../components/operations/tally/manage-tally/manage-tally-destuffing-fcl/manage-tally-destuffing-fcl.component";
import {
  ManageTallyDestuffingFclTruckComponent
} from "../components/operations/tally/manage-tally/manage-tally-destuffing-fcl-truck/manage-tally-destuffing-fcl-truck.component";
import { NoDataComponent } from "../components/no-data/no-data.component";
import {
  ManageTallyDestuffingLclComponent
} from "../components/operations/tally/manage-tally/manage-tally-destuffing-lcl/manage-tally-destuffing-lcl.component";



export const Lane = {
  LANE01: {value: "Lane 1", key: "LANE01"},
  LANE02: {value: "Lane 2", key: "LANE02"},
  LANE03: {value: "Lane 3", key: "LANE03"},
} as const;
export type Lane = typeof Lane[keyof typeof Lane];

export enum InventoryType {
  CONTAINER = "CONTAINER",
  TRUCK = "TRUCK",
  TRAILER = "TRAILER",
  CARGO = "CARGO"
}

type GateInOption = {
  label: string;
  cycle: typeof CycleType[keyof typeof CycleType] | null;
  vehicleType: InventoryType[];
};

export const GateInTypes: Record<string, GateInOption> = {
  IMPORT_LOADED_CONTAINER: { label: "Loaded Container", cycle: CycleType.IMPORT, vehicleType: [InventoryType.CONTAINER] },
  IMPORT_EMPTY_CONTAINER: { label: "Empty Container", cycle: CycleType.IMPORT, vehicleType: [InventoryType.CONTAINER] },
  SCAN_AREA_RETURN: { label: "Scan Area Return", cycle: CycleType.IMPORT, vehicleType: [InventoryType.CONTAINER] },
  IMPORT_FCL_DESTUFF_DELIVERY: { label: "FCL Destuff Delivery", cycle: CycleType.IMPORT, vehicleType: [InventoryType.TRUCK, InventoryType.TRAILER] },
  IMPORT_FCL_LOADED_DELIVERY: { label: "FCL Loaded Delivery", cycle: CycleType.IMPORT, vehicleType: [InventoryType.TRUCK, InventoryType.TRAILER] },
  IMPORT_LCL_DELIVERY: { label: "LCL Delivery", cycle: CycleType.IMPORT, vehicleType: [InventoryType.TRUCK] },
  IMPORT_HUB_DELIVERY: { label: "Hub Delivery", cycle: CycleType.IMPORT, vehicleType: [InventoryType.TRUCK] },
  IMPORT_BREAK_BULK: { label: "Break Bulk", cycle: CycleType.IMPORT, vehicleType: [InventoryType.TRAILER] },

  EXPORT_STUFFING: { label: "Export Stuffing", cycle: CycleType.EXPORT, vehicleType: [InventoryType.CONTAINER] },
  EXPORT_BUFFER_CONTAINER: { label: "Factory/Buffer Container", cycle: CycleType.EXPORT, vehicleType: [InventoryType.CONTAINER] },
  EXPORT_HUB: { label: "Export Hub", cycle: CycleType.EXPORT, vehicleType: [InventoryType.TRUCK, InventoryType.CONTAINER] },
  ON_WHEEL: { label: "On Wheel", cycle: CycleType.EXPORT, vehicleType: [InventoryType.CONTAINER] },
  EXPORT_TERMINAL_RETURN: { label: "Return From Terminal", cycle: CycleType.EXPORT, vehicleType: [InventoryType.CONTAINER] },
  EXPORT_CARTING: { label: "Export Carting", cycle: CycleType.EXPORT, vehicleType: [InventoryType.TRUCK] },
  EXPORT_BACK_TO_TOWN: { label: "Back Top Town", cycle: CycleType.EXPORT, vehicleType: [InventoryType.TRUCK] },
  EXPORT_BREAK_BULK: { label: "Break Bulk", cycle: CycleType.EXPORT, vehicleType: [InventoryType.TRAILER] },
  EXPORT_CONTAINER_PICKUP: { label: "Export Container Pickup", cycle: CycleType.EXPORT, vehicleType: [InventoryType.TRAILER] },

  EMPTY_CONTAINER_FROM_YARD: { label: "From Empty Yard", cycle: CycleType.EMPTY, vehicleType: [InventoryType.CONTAINER] },
  EMPTY_CONTAINER_HUB: { label: "Hub Stuffing", cycle: CycleType.EMPTY, vehicleType: [InventoryType.CONTAINER] },
  EMPTY_CONTAINER_PICKUP: { label: "Empty Container Pickup", cycle: CycleType.EMPTY, vehicleType: [InventoryType.TRAILER] },

  IN_BONDING: { label: "In Bonding", cycle: CycleType.BOND, vehicleType: [InventoryType.TRUCK, InventoryType.CONTAINER] },
  EX_BONDING: { label: "Ex Bonding", cycle: CycleType.BOND, vehicleType: [InventoryType.TRUCK, InventoryType.TRAILER, InventoryType.CONTAINER] },
} as const;

export type GateInType = typeof GateInTypes[keyof typeof GateInTypes];

export function getGateInOptions(vehicleType: InventoryType) {
  return Object.entries(GateInTypes)
  .filter(([_, value]) => value.vehicleType.includes(vehicleType))
  .map(([key, value]) => ({
    key,
    label: value.label,
    cycle: value.cycle,
  }));
}

export const JobOrderType = {
  SEAL_CUT_EXAMINATION: { value: "Seal Cut & Examination", key: "SEAL_CUT_EXAMINATION", cycle: [CycleType.IMPORT] },
  RMS_AND_EXAMINATION: { value: "RMS & Examination", key: "RMS_AND_EXAMINATION", cycle: [CycleType.IMPORT] },
  RMS_SEAL_VERIFICATION: { value: "RMS Seal Verification", key: "RMS_SEAL_VERIFICATION", cycle: [CycleType.IMPORT] },
  FACTORY_DELIVERY: { value: "Loaded Delivery", key: "FACTORY_DELIVERY", cycle: [CycleType.IMPORT] },
  DOCK_DELIVERY: { value: "Destuff Delivery", key: "DOCK_DELIVERY", cycle: [CycleType.IMPORT] },
  LCL_DESTUFF: { value: "LCL Destuff", key: "LCL_DESTUFF", cycle: [CycleType.IMPORT] },
  LCL_DELIVERY: { value: "LCL Delivery", key: "LCL_DELIVERY", cycle: [CycleType.IMPORT] },
  SMTP_TRUCK_MOVEMENT: { value: "Hub Truck Movement", key: "SMTP_TRUCK_MOVEMENT", cycle: [CycleType.IMPORT] },
  SMTP_STUFFING: { value: "Hub Stuffing", key: "SMTP_STUFFING", cycle: [CycleType.IMPORT] },
  SMTP_CONTAINER_DELIVERY: { value: "Hub Container Delivery", key: "SMTP_CONTAINER_DELIVERY", cycle: [CycleType.IMPORT] },
  CARTING: { value: "Carting", key: "CARTING", cycle: [CycleType.EXPORT] },
  STUFFING: { value: "Stuffing", key: "STUFFING", cycle: [CycleType.EXPORT] },
  SSR: { value: "SSR", key: "SSR", cycle: [CycleType.IMPORT, CycleType.EXPORT]},

} as const;
export type JobOrderType = typeof JobOrderType[keyof typeof JobOrderType];
export type JobOrderTypeKey = keyof typeof JobOrderType;

export const getJobOrderByKey = (key: string) => {
  return Object.values(JobOrderType).find((type) => type.key === key) || null;
};

export const getJobOrderTypeByValue = (value: string) => {
  return Object.values(JobOrderType).find((type) => type.value === value) || null;
};

export function getJobOrderTypesByCycle(cycle: string) {
  return Object.entries(JobOrderType)
    .filter(([_, value]) => value.cycle.some((c: Cycle) => c.key === cycle))
    .map(([_, value]) => ({
      key: value.key,
      value: value.value,
      cycle
    }));
}

export const UploadType = {
  IGM: { label: "IGM/CGM", key: "igm" },
  CSV: { label: "CSV", key: "csv" },
  SCAN_LIST: { label: "Scan List", key: "scanList" }
} as const;


export const ScanType = {
  D: { label: "D", key: "D" },
  M: { label: "M", key: "M" },
  F: { label: "F", key: "F" },
  NR: { label: "Not Required", key: "NR" },
  NU: { label: "Not Received", key: "NU" }
} as const;
export type ScanType = typeof ScanType[keyof typeof ScanType];

export const ScanStatus = {
  CLEARED: { label: "Cleared", key: "CLEARED" },
  EXAMINATION: { label: "100% Examination", key: "EXAMINATION" },
  SUSPICIOUS: { label: "Suspicious", key: "SUSPICIOUS" },
  NOT_SCANNED: { label: "Not Scanned", key: "NOT_SCANNED" },
  NOT_REQUIRED: { label: "Not Required", key: "NOT_REQUIRED" },
  RESTRICTED: { label: "Restricted", key: "RESTRICTED" }
} as const;
export type ScanStatus = typeof ScanStatus[keyof typeof ScanStatus];

export const Condition = {
  SOUND: { label: "Sound", key: "SOUND" },
  DAMAGED: { label: "Damaged", key: "DAMAGED" },
  BAD: { label: "Bad", key: "BAD" }
} as const;
export type Condition = typeof Condition[keyof typeof Condition];

export const ImportType = {
  FCL: { label: "FCL", key: "FCL" },
  LCL: { label: "LCL", key: "LCL" },
} as const;
export type ImportType = typeof ImportType[keyof typeof ImportType];

export const DeliveryMode = {
  FACTORY: { label: "Loaded Delivery", key: "FACTORY" },
  DOCK: { label: "Destuff Delivery", key: "DOCK" },
} as const;
export type DeliveryMode = typeof DeliveryMode[keyof typeof DeliveryMode];


//Tally Type
export const TallyType = {
  RMS_EXAMINATION_TALLY: {
    displayName: "RMS and Examination Tally",
    code: "RMS_EXAMINATION_TALLY",
    component: ManageExaminationTallyComponent
  },
  SEAL_CUT_EXAMINATION_TALLY: {
    displayName: "Seal Cut and Examination Tally",
    code: "SEAL_CUT_EXAMINATION_TALLY",
    component: ManageExaminationTallyComponent
  },
  DOCK_DELIVERY_TALLY: {
    displayName: "Dock Delivery Tally",
    code: "DOCK_DELIVERY_TALLY",
    component: NoDataComponent,
    getComponent: (details?: any) => {
      if (details?.additionalDetails?.destuffTo === "TRUCK") {
        return ManageTallyDestuffingFclTruckComponent;
      }else{
        return ManageTallyDestuffingFclComponent;
      }
    }
  },
  LCL_DESTUFF_TALLY: {
    displayName: "LCL Destuff Tally",
    code: "LCL_DESTUFF_TALLY",
    component: ManageTallyDestuffingLclComponent
  },
  LCL_DELIVERY_TALLY: {
    displayName: "Loose Cargo Delivery Tally",
    code: "LCL_DELIVERY_TALLY",
    component: ManageLclDeliveryTallyComponent
  },
  SMTP_TRUCK_MOVEMENT_TALLY: {
    displayName: "SMTP Truck Movement Tally",
    code: "SMTP_TRUCK_DELIVERY_TALLY",
    component: ManageTallySmtpTruckMovementComponent
  },
  SMTP_STUFFING_TALLY: {
    displayName: "SMTP Stuffing Tally",
    code: "SMTP_CONTAINER_STUFFING_TALLY",
    component: ManageSmtpStuffingTallyComponent
  },
  SMTP_CONTAINER_DELIVERY_TALLY: {
    displayName: "SMTP Container Delivery Tally",
    code: "SMTP_CONTAINER_DELIVERY_TALLY",
    component: NoDataComponent //TODO: Change this to ManageTallySmtpContainerDeliveryComponent if this tally is required
  }
} as const;
export type TallyType = typeof TallyType[keyof typeof TallyType];

export const JobOrderTypeVsTallyType: Partial<Record<JobOrderTypeKey, TallyType>> = {
  RMS_AND_EXAMINATION: TallyType.RMS_EXAMINATION_TALLY,
  SEAL_CUT_EXAMINATION: TallyType.SEAL_CUT_EXAMINATION_TALLY,
  LCL_DESTUFF: TallyType.LCL_DESTUFF_TALLY,
  DOCK_DELIVERY: TallyType.DOCK_DELIVERY_TALLY,
  LCL_DELIVERY: TallyType.LCL_DELIVERY_TALLY,
  SMTP_STUFFING: TallyType.SMTP_STUFFING_TALLY,
  SMTP_CONTAINER_DELIVERY: TallyType.SMTP_CONTAINER_DELIVERY_TALLY,
  SMTP_TRUCK_MOVEMENT: TallyType.SMTP_TRUCK_MOVEMENT_TALLY
};

export function getTallyTypeByJobOrderType(jobOrderType: string): TallyType | undefined {
  const jobOrderKey = jobOrderType as JobOrderTypeKey;
  return JobOrderTypeVsTallyType[jobOrderKey];
}

export const HoldType = {
  INTERNAL: {label: "Internal", key: "INTERNAL"},
  CUSTOMS: {label: "Customs", key: "CUSTOMS"}
} as const;
export type HoldType = typeof HoldType[keyof typeof HoldType];

export const HoldSource = {
  SIIB: { label: "SIIB", key: "SIIB", holdType: HoldType.CUSTOMS },
  DRI: { label: "DRI", key: "DRI", holdType: HoldType.CUSTOMS },
  RI: { label: "R&I", key: "RI", holdType: HoldType.CUSTOMS },
  CCCP: { label: "CCCP", key: "CCCP", holdType: HoldType.CUSTOMS },
  OPERATIONS: { label: "Operations", key: "OPERATIONS", holdType: HoldType.INTERNAL },
  FINANCE: { label: "Finance", key: "FINANCE", holdType: HoldType.INTERNAL }
} as const;
export type HoldSource = typeof HoldSource[keyof typeof HoldSource];

export const HoldReason = {
  SEAL_MISMATCH: { label: "Seal Mismatch", key: "SEAL_MISMATCH", holdSource: HoldSource.OPERATIONS },
  SCAN_INFO_MISSING: { label: "Scan Info Missing", key: "SCAN_INFO_MISSING", holdSource: HoldSource.OPERATIONS },
  SCAN_REQUIRED: { label: "Scanning Required", key: "SCAN_REQUIRED", holdSource: HoldSource.OPERATIONS },
  DELIVERY_ORDER_NOT_SUBMITTED: { label: "DO Not Submitted", key: "DELIVERY_ORDER_NOT_SUBMITTED", holdSource: HoldSource.OPERATIONS },
  CARGO_OR_CONTAINER_DAMAGED: { label: "Cargo/Container Damaged", key: "CARGO_OR_CONTAINER_DAMAGED", holdSource: HoldSource.OPERATIONS },
  DOCUMENT_NOT_SUBMITTED: { label: "Document Not Submitted", key: "DOCUMENT_NOT_SUBMITTED", holdSource: HoldSource.OPERATIONS },
  CREDIT_LIMIT_EXCEEDED: { label: "Credit limit exceeded", key: "CREDIT_LIMIT_EXCEEDED", holdSource: HoldSource.FINANCE },
  OTHER: { label: "Other", key: "OTHER", holdSource: null }
} as const;
export type HoldReason = typeof HoldReason[keyof typeof HoldReason];

export function getHoldReasonForSource(holdSource: HoldSource): any[]  {
  return Object.entries(HoldReason)
    .filter(([_, value]) => !value.holdSource ||  value.holdSource.key === holdSource.key)
    .map(([_, value]) => ({
      key: value.key,
      label: value.label,
      holdSource: value.holdSource
    }));
}


export const GateOutModes = {
  IMPORT_LOADED_CONTAINER: { label: "Loaded Container", vehicleType: [InventoryType.CONTAINER], jobOrderType: [JobOrderType.FACTORY_DELIVERY]},
  IMPORT_EMPTY_CONTAINER: { label: "Empty Container - Import", vehicleType: [InventoryType.CONTAINER] },
  //TRANSFER_TO_SCAN_AREA: { label: "Transfer to Scan Area", vehicleType: [InventoryType.CONTAINER], jobOrderType: [JobOrderType.TRANSFER_TO_SCAN_AREA]},
  IMPORT_DESTUFF_DELIVERY: { label: "Destuff Delivery", vehicleType: [InventoryType.TRUCK], jobOrderType: [JobOrderType.DOCK_DELIVERY]},
  IMPORT_LCL_DELIVERY: { label: "LCL Delivery", vehicleType: [InventoryType.TRUCK], jobOrderType: [JobOrderType.LCL_DELIVERY] },
  IMPORT_HUB_DELIVERY: { label: "Hub Delivery - Import", vehicleType: [InventoryType.TRUCK, InventoryType.CONTAINER], obOrderType: [JobOrderType.SMTP_TRUCK_MOVEMENT, JobOrderType.SMTP_CONTAINER_DELIVERY] },
  IMPORT_BREAK_BULK: { label: "Break-Bulk", vehicleType: [InventoryType.TRAILER] },
  EX_BONDING: { label: "Ex-Bonding", vehicleType: [InventoryType.TRUCK, InventoryType.CONTAINER] },
  EMPTY_TRUCK: { label: "Empty Truck", vehicleType: [InventoryType.TRUCK] },
  EMPTY_TRAILER: { label: "Empty Trailer", vehicleType: [InventoryType.TRAILER] }
} as const;
export type GateOutMode = typeof GateOutModes[keyof typeof GateOutModes];

export function getGateOutModes(vehicleType: InventoryType) {
  return Object.entries(GateOutModes)
  .filter(([_, value]) => (value.vehicleType as ReadonlyArray<InventoryType>).includes(vehicleType))
  .map(([key, value]) => ({
    key,
    label: value.label,
  }));
}

